import validatorBuilder from 'validator-builder';

let referenceControleCaracteristiquesValidator = null;

export default class ReferenceControleCaracteristiques {
    constructor(data) {
        referenceControleCaracteristiquesValidator =
            referenceControleCaracteristiquesValidator || validatorBuilder.getInstanceFor('ReferenceControleCaracteristiques');
        referenceControleCaracteristiquesValidator.clearRules();
        referenceControleCaracteristiquesValidator.generateRules();

        this.data = {};
        for (const element in data) {
            if (element !== 'data') {
                this[element] = data[element];
                this.data[element] = {
                    id: parseInt(element),
                    value: getFormattedValues(data[element]),
                    additionalInformations: { key: 'clé', value: 'valeur' }
                };
            }
        }

        function getFormattedValues(element) {
            if (Array.isArray(element)) {
                const result = _.map(element, function (e) {
                    if (e && e.hasOwnProperty('key')) {
                        return { value: e.key };
                    }
                    return { value: e };
                });
                return result;
            }
            return element;
        }
    }

    isValid() {
        const validationResults = referenceControleCaracteristiquesValidator.validate(this);
        return validationResults.isValid;
    }
}
